import { APICore } from './apiCore';

const api = new APICore();

// -------------------- Modules API --------------------

// List all modules
export function moduleList(data?: any) {
    return api.create('/subscription/module/list', data);
}

// Add a new module
export function moduleAdd(data: any) {
    return api.create('/subscription/module/add', data);
}

// Delete a module
export function moduleDelete(data: any) {
    return api.delete('/subscription/module/delete', data);
    // data example: { module_id: 'module-uuid' }
}

// Update a module
export function moduleUpdate(data: any) {
    return api.update('/subscription/module/update', data);
    // data example:
    // {
    //   "module_id": "abc123",
    //   "module_name": "Module A",
    //   "description": "Module description"
    // }
}

// Update module status (activate/deactivate)
export function moduleUpdateStatus(data: any) {
    return api.update('/subscription/module/update-status', data);
    // data example:
    // {
    //   "module_id": "abc123",
    //   "is_active": true
    // }
}
